import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import '../utilities/loading-animation'
import '../utilities/form-ajax-error'
import '../utilities/form-error-modal'
import './../wirebox/utilities/scroll-to-target'
import './../wirebox/components/cached-script'

const FormValidation = {
    
    run() {
        
        jQuery('form.validate').each((i, element) => {

            let
                currentForm = jQuery(element),
                equalTos = currentForm.find('[data-equal-to][data-equal-to!=""]'),
                creditCards = currentForm.find('[data-credit-card][data-credit-card!=""]'),
                input,
                rules = {}
            
            //Compile equal-to rules
            equalTos.each((i, element) => {
                input = jQuery(element)
                rules[input.attr('name')] = {
                    equalTo: input.data('equal-to')
                }
            })
            
            //Compile credit card rules
            creditCards.each((i, element) => {
                input = jQuery(element)
                rules[input.attr('name')] = {
                    creditcard: true
                }
            })
            
            let validator = currentForm.validate({
                errorClass: 'error',
                validClass: 'valid',
                errorPlacement: (error, element) => {
                    return
                },
                focusInvalid: currentForm.data('no-scroll'),
                ignore: '',
                rules: rules,
                submitHandler: (form) => {
                    
                    //Cancel if form has submitted" data attribute
                    if (currentForm.data('submitted') || currentForm.hasClass('.no-submit')) {
                        return
                    }
                    
                    //Trigger success event on form to be received in module
                    currentForm.trigger('form-success')
                    
                    //Cancel if form should not have default submission
                    if (currentForm.hasClass('no-submit')) {
                        return
                    }
                    
                    //Default form submit if an action attribute is present
                    if (currentForm.attr('action')) {
                        
                        //Prepare form for submision
                        EventBus.publish('prepare-form-submit', currentForm)
                        
                        //Allow form data to be intercepted prior to sending to server
                        EventBus.publish('form-submitting', currentForm)
                        
                        //Invoke submit function on default form element
                        form.submit()
                        
                        return
                        
                    }
                    
                    //Broadcast an event that the form is submitting
                    var submitEvent = currentForm.data('submit-event')
                    if (submitEvent) {
                        EventBus.publish(submitEvent, currentForm)
                        return
                    }
                    
                    //Generic AJAX form submit
                    var url = currentForm.data('ajax-url')
                    if (url) {
                        
                        //Prepare form for submision
                        EventBus.publish('prepare-form-submit', currentForm)
                        
                        //Post request to server
                        jQuery.post(url, currentForm.serialize(), (response) => {
                            
                            //Trigger ajax success event on form
                            currentForm.trigger('form-ajax-success', {
                                form: currentForm,
                                response: response
                            })
                            
                            //Handle auto-direct
                            if (currentForm.data('redirect')) {
                                window.location = response.redirect
                                return
                            }
                            
                            //Remove preparation of form submision
                            EventBus.publish('unprepare-form-submit', currentForm)
                            
                            //Handle HTML response
                            if (response.hasOwnProperty('html')) {
                                
                                currentForm.data('validator').destroy()
                                let html = jQuery('<div>' + response.html + '</div>')
                                currentForm.replaceWith(html)
                                html.hide().fadeIn()

                                EventBus.publish('scroll-to-target', {
                                    target: html
                                })
                                
                            }
                            
                        }).fail((xhr) => {
                            
                            //Trigger ajax fail event on form
                            currentForm.trigger('form-ajax-error', xhr)
                            
                            //Remove preparation of form submision
                            EventBus.publish('unprepare-form-submit', currentForm)
                            
                        })
                    }
                        
                },
                invalidHandler: (event, validator) => {
                    
                    let invalid = jQuery(validator.errorList[0].element);
                    
                    if (!currentForm.data('no-scroll')) {
                        EventBus.publish('scroll-to-target', {
                                center: true,
                                target: currentForm.find('label[for="' + invalid.attr('id') + '"]')
                        })
                    }
                    
                    currentForm.trigger('form-errors', validator)
                    
                }
            });
            
            //Apply validator to form
            currentForm.data('validator', validator)
                
        })
        
        //Apply localisation to validation messages
        if (typeof validationLocale !== 'undefined') {
            jQuery.cachedScript(validationLocale)
        }
        
    },
        
    bindEvents() {
        
        //Run component
        EventBus.subscribe('run-modules', this.run)

        //Prepare form submit
        EventBus.subscribe('prepare-form-submit', (form) => {
            
            //Add loading class if data attribute present
            if (form.data('use-loading-class')) {
                EventBus.publish('loading.start', form.data('body-loading') ? jQuery('body') : form)
            }
            
            //Disable form fieldsets if attribute is present
            if (form.data('disable-on-submit')) {
                
                if (form.data('submitted')) {
                    return
                }
                
                form.data('submitted', true)
                
            }
            
        })

        //Unprepare form submit
        EventBus.subscribe('unprepare-form-submit', (form) => {
            
            //Remove loading class if data attribute present
            if (form.data('use-loading-class')) {
                EventBus.publish('loading.stop', form.data('body-loading') ? jQuery('body') : form)
            }
            
            //Enable form fieldsets if attribute is present
            if (form.data('disable-on-submit')) {
                form.data('submitted', false)
            }
            
        })
        
    }
    
}

FormValidation.bindEvents()

export default FormValidation